import { useContext } from 'react'
import RouteAnimationContext from 'animations/routeAnimationContext'
import { Shield } from 'components/common'
import { Container, Wrapper } from './AnimationContainer.styled'

const AnimationContainer: React.FC = ({ children }) => {
  const { isAnimationRun, isAnimationHalfLife } = useContext(RouteAnimationContext)

  return (
    <Container data-test='AnimationContainer'>
      <Wrapper startAnimation={isAnimationRun} halfLifeAnimation={isAnimationHalfLife}>
        {children}
      </Wrapper>
      {isAnimationRun && <Shield variant='upAndDown' />}
    </Container>
  )
}

export default AnimationContainer
